
import {
  actionCreator,
  CANCEL_APPOINTMENT_API,
  CHECK_ISVALID_APPOINTMENT_API,
  checkHttpStatus,
  createSearchUrlScheduling,
  DELETE_APPOINTMENT_API,
  GET_APPOINTMENT_API,
  GET_APPOINTMENT_DATA_API,
  GET_DATA_FOR_SCHEDULER_API,
  GET_DATA_FOR_SCHEDULER_NEWAPPOINTMENT_API,
  GET_MASTERDATABYNAME,
  GET_OFFICE_HOURS_API,
  GET_PATIENT,
  GET_PATIENT_AUTHORIZATION_DETAIL_API,
  GET_STAFF_AND_PATIENT_BYLOCATION,
  GET_STAFFS_AVAILABILITY,
  GET_CLIENTS_AVAILABILITY, 
  jsonApiHeader,
  PATIENT_AUTHORIZATIONS_LIST_API,
  PATIENT_PAYERS_API,
  POST_APPOINTMENT_API,
  POST_APPOINTMENT_FROM_PATIENT_PORTAL_API,
  schedulingActionTypes,
  showSuccessMessage,
  UNDO_CANCELLED_APPOINTMENT_API,
  UPDATE_APPOINTMENT_STATUS_API, 
  UPDATE_SEND_APPOINTMENT_NOTIFICATION_API,
  GET_PATIENT_CLINICAL_ROOM_AVAILABILITY_API,
  POST_UPLOADDOCUMENTS,
  showWarningMessage,
  PATIENT_PAYERS_BYPATIENTIDANDDOS_API,
  GET_PATIENT_INSURANCE_DETAIL_API,  
  GET_AUDITLOG_FORSESSION,
  GET_IN_ACTIVE_STAFF_AND_PATIENT_BY_LOCATION,
  GET_ONLY_IN_ACTIVE_STAFF_AND_PATIENTS_BY_LOCATION,
  CHECK_ISVALID_APPOINTMENT_PATIENT,
  GET_APPOINTMENTTYPE_DEFAULT_SETTING, 
} from '../constants/ApiConstants';
import Alert from 'react-s-alert';
import moment from 'moment';
import history from '../../../history';
import { showErrorMessage, BEHAVIOR_BLOSSOMS, EBS, NE_ABA, BESTABA, DEMO, CBG, AIP, BUILDABLOCKTHERAPY, SWANCONSULTINGINC, CAS, VICTORIOUSLEARNING, ABAORLANDO, POSITIVEBEHAVIORSTEPS, SOAR, HYPERIONCENTER, HELPINGHANDS, FUTURES, TFABA, IAT, AMEGO, ADASTRA, CWO, AMEGOFL, VIP, SBS, createSearchUrlForCustomAPI,checkHttpStatusAuthCheck } from '../../../actions/utilAction';

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(schedulingActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error master data ----', error);
      });
  };
};

export const getAppointments = (searchObj) => {
  let query_params = createSearchUrlScheduling(searchObj);
  // console.log(`${GET_APPOINTMENT_API}${query_params}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_appointments.REQUEST));
    fetch(`${GET_APPOINTMENT_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(schedulingActionTypes.get_appointments.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const getAppointmentData = (appointment_id) => {
  // let query_params = createSearchUrl(searchObj);
  // console.log(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_appointment_by_id.REQUEST));
    fetch(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(schedulingActionTypes.get_appointment_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get appointment_by_id error', error);
      });
  };
};

export const deleteAppointmentData = (appointmentId, parentAppointmentId, deleteSeries, isAdmin = false) => {
  // console.log('inside deleteAppointment: ', appointment_id);
  Alert.closeAll();
  let query_params = `?appointmentId=${appointmentId}&parentAppointmentId=${parentAppointmentId}&deleteSeries=${deleteSeries}&isAdmin=${isAdmin}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.delete_appointment.REQUEST));
    fetch(`${DELETE_APPOINTMENT_API}${query_params}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        Alert.success(response.message, {
          position: 'bottom-right',
          effect: 'slide',
        });
        dispatch(actionCreator(schedulingActionTypes.delete_appointment.SUCCESS));
      }).catch(function(error) {
        console.log('appointment delete error (scheduling actions)...', error);
      });
  };
};

export const deleteAppointmentDataFromReoccurrence = (appointmentData, parentAppointmentId, deleteSeries, agencyName, isAdmin = false, BatchParentAppointmentId = 0,isFinish = false) => {
  // console.log('inside deleteAppointment: ', appointment_id);
  Alert.closeAll();
  let query_params = `?appointmentId=${appointmentData[0].PatientAppointmentId}&parentAppointmentId=${parentAppointmentId}&deleteSeries=${deleteSeries}&isAdmin=${isAdmin}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.delete_appointment.REQUEST));
    fetch(`${DELETE_APPOINTMENT_API}${query_params}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
         // let isFinish = false;
          appointmentData[0].PatientAppointmentId = 0;        
          appointmentData[0].BatchParentAppointmentId = BatchParentAppointmentId;    
          dispatch(createAppointment(appointmentData, isFinish, agencyName));
        }
        dispatch(actionCreator(schedulingActionTypes.delete_appointment.SUCCESS));
      }).catch(function(error) {
        console.log('appointment delete error (scheduling actions)...', error);
      });
  };
};

export const deleteAppointmentBulkDataFromReoccurrence = (appointmentData, parentAppointmentId, deleteSeries, agencyName, isAdmin = false, BatchParentAppointmentId = 0,isFinish = false) => {
  // console.log('inside deleteAppointment: ', appointment_id);
  Alert.closeAll();
  let query_params = `?appointmentId=${appointmentData[0].PatientAppointmentId}&parentAppointmentId=${parentAppointmentId}&deleteSeries=${deleteSeries}&isAdmin=${isAdmin}&batchParentAppointmentId=${appointmentData[0].BatchParentAppointmentId}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.delete_appointment.REQUEST));
    fetch(`${DELETE_APPOINTMENT_API}${query_params}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          //let isFinish = false;
          appointmentData[0].PatientAppointmentId = 0;        
          appointmentData[0].BatchParentAppointmentId = BatchParentAppointmentId;        
          dispatch(createAppointment(appointmentData, isFinish, agencyName));
        }
        dispatch(actionCreator(schedulingActionTypes.delete_appointment.SUCCESS));
      }).catch(function(error) {
        console.log('appointment delete error (scheduling actions)...', error);
      });
  };
};

export const cancelAppointment = (formData) => {
  // let query_params = createSearchUrl(searchObj);
  // console.log(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`);
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.cancel_appointment.REQUEST));
    fetch(`${CANCEL_APPOINTMENT_API}`, {
      method: 'post',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
        // console.log('response: ', response);
        showSuccessMessage(response.message);
        }
        else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(schedulingActionTypes.cancel_appointment.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('cancel appointment error', error);
      });
  };
};

export const undoCancelledAppointment = (appointmentId) => {
  let query_params = `?appointmentId=${appointmentId}`;
  // console.log(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.undoCancelled_appointment.REQUEST));
    fetch(`${UNDO_CANCELLED_APPOINTMENT_API}${query_params}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(schedulingActionTypes.undoCancelled_appointment.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('undo cancelled appointment error', error);
      });
  };
};


export const getStaffsAndPatientsByLocation = (searchObj, isCallFromDailog) => {
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=${searchObj.permissionKey}&isActiveCheckRequired=${searchObj.isActiveCheckRequired}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnly}`;
  // console.log(`${GET_STAFF_AND_PATIENT_BYLOCATION}?locationId=${locationId}`);
  return (dispatch, getState) => {
    if (isCallFromDailog) {
      dispatch(actionCreator(schedulingActionTypes.get_staff_and_patient_bySingleLocation.REQUEST));
    } else {
      dispatch(actionCreator(schedulingActionTypes.get_staff_and_patient_bylocation.REQUEST));
    }
    fetch(`${GET_STAFF_AND_PATIENT_BYLOCATION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        if (isCallFromDailog) {
          dispatch(actionCreator(schedulingActionTypes.get_staff_and_patient_bySingleLocation.SUCCESS, response));
        } else {
          dispatch(actionCreator(schedulingActionTypes.get_staff_and_patient_bylocation.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('get staff and client by location error', error);
      });
  };
};


// export const getAllAppointments = (searchObj, newSearchObj, filterDateObj) => {
//   // console.log('filterDateObj...', filterDateObj);
//   let dateFilters = `&filter[fromdate]=${filterDateObj.fromDate}&filter[todate]=${filterDateObj.toDate}`;
//   return (dispatch, getState) => {
//     dispatch(actionCreator(schedulingActionTypes.get_appointments.REQUEST));
//     if (searchObj === 'fetchAllAppoinment') {
//       // let emptydata = { data: [] };
//       let query_params = '?include=patient,appointmenttype,appointmentstaff,patientencounter';
//       fetch(`${APPOINTMENT_API}${query_params}${dateFilters}`, {
//         method: 'get',
//         headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//       })
//         .then(checkHttpStatus)
//         .then(function(response) {
//           // console.log('response: ', response);
//           dispatch(actionCreator(schedulingActionTypes.get_appointments.SUCCESS, response));
//         })
//         .catch(function(error) {
//           // errorHandler(error);
//         });
//       // dispatch(actionCreator(schedulingActionTypes.get_appointments.SUCCESS, emptydata));
//     } else {
//       let query_params = createMultiSearchUrlScheduling(searchObj, newSearchObj);
//       fetch(`${APPOINTMENT_API}${query_params}${dateFilters}`, {
//         method: 'get',
//         headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//       })
//         .then(checkHttpStatus)
//         .then(function(response) {
//           // console.log('Query Exist: ', response);
//           dispatch(actionCreator(schedulingActionTypes.get_appointments.SUCCESS, response));
//         })
//         .catch(function(error) {
//           // errorHandler(error);
//         });
//     }
//   };
// };


// export const getAllAppointmentsNotFilter = () => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(schedulingActionTypes.get_appointments.REQUEST));
//     fetch(`${APPOINTMENT_API}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('response: ', response);
//         dispatch(actionCreator(schedulingActionTypes.get_appointments.SUCCESS, response));
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//       });
//   };
// };

// export const getAppointmentById = (id) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(schedulingActionTypes.get_appointment_by_id.REQUEST));
//     fetch(`${APPOINTMENT_API}/${id}?include=patient,appointmenttype,appointmentstaff,patientencounter`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(schedulingActionTypes.get_appointment_by_id.SUCCESS, response));
//       })
//       .catch(function(error) {
//       // errorHandler(error);
//       });

//   };


// };

export const checkIsValidAppointment = (formProps, requestName = null) => {
  // console.log('patient-appointment', JSON.stringify(formProps));
  Alert.closeAll();
  return (dispatch, getState) => {
    if (requestName) {
      dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment_inUndoCancel.REQUEST));
    } else {
      dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment.REQUEST));
    }
    fetch(`${CHECK_ISVALID_APPOINTMENT_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('checked appointment response ...', response, formProps);
        let appointmentData = {
          isValid: true,
          errorMessage: '',
          formData: formProps,
          requestName: requestName,
        };
        let data = response.data;
        let messagesArray = [];
        let isValidAppointment = true;
        if (data && data.length) {
          messagesArray = data.map((obj) => {
            if (!obj.valid) {
              isValidAppointment = obj.valid;
              return obj.message;
            } else {
              return null;
            }
          });
        }
        appointmentData['isValid'] = isValidAppointment;
       let appointmentDataMessage = messagesArray.join(', ');
        appointmentData['errorMessage']  = appointmentDataMessage.replace(/,\s*$/, "");        
        if (requestName) {
          dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment_inUndoCancel.SUCCESS, appointmentData));
        } else {
          dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment.SUCCESS, appointmentData));
        }
        // if (isValidAppointment) {
        //   dispatch(createAppointment(formProps, true));
        // } else {
        //   let alertMessage = messagesArray.join(', ') + ', Still want to continue?';
        //   let alertConfig = {
        //     defaultButton: {
        //       handleClick: () => dispatch(createAppointment(formProps, true)),
        //       param: formProps,
        //     },
        //   };
        //   alertConfirmation(alertMessage, alertConfig);
        // }
      })
      .catch(function(error) {
        if (requestName) {
          dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment_inUndoCancel.FAILURE, null));
        } else {
          dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment.FAILURE, null));
        }
        console.log('error----', error);
      });
  };
};

export const checkIsValidAppointmentPatient = (formProps) => {
  // console.log('patient-appointment', JSON.stringify(formProps));
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment_patient.REQUEST));
    fetch(`${CHECK_ISVALID_APPOINTMENT_PATIENT}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('checked appointment response ...', response, formProps);
        if (response.statusCode === 200) {
          dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment_patient.SUCCESS, response));
        } else {
          dispatch(actionCreator(schedulingActionTypes.check_isValidAppointment_patient.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error----', error);
      });
  };
};

export const createAppointmentFromPatientPortal = (formProps) => {
  // console.log('patient-appointment', JSON.stringify(formProps));
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.save_appointment.REQUEST));
    fetch(`${POST_APPOINTMENT_FROM_PATIENT_PORTAL_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(schedulingActionTypes.save_appointment.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(schedulingActionTypes.save_appointment.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error----', error);
      });
  };
};

export const createAppointment = (formProps, IsFinish, agencyName = 'VIP', isAdminUpdate = false, isMileageUpdatedByStaff = false) => {
  // console.log('patient-appointment', JSON.stringify(formProps));
  //  console.log('isAdminUpdate.......', isAdminUpdate);
  //  console.log('isMileageUpdatedByStaff.......', isMileageUpdatedByStaff);
  //  console.log('IsFinish.......', IsFinish);
  let query_params = '';
  Alert.closeAll();
  return (dispatch, getState) => {
    if (IsFinish) {
      query_params = `?IsFinish=${IsFinish}&isAdmin=${isAdminUpdate}&isMileageUpdatedByStaff=${isMileageUpdatedByStaff}`;
      dispatch(actionCreator(schedulingActionTypes.save_appointment.REQUEST));
    } else {
      dispatch(actionCreator(schedulingActionTypes.verify_Recurrence_appointments.REQUEST));
    }
    fetch(`${POST_APPOINTMENT_API}${query_params}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (IsFinish) {
          dispatch(actionCreator(schedulingActionTypes.save_appointment.SUCCESS, response));
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            // in Admin Update after rendering, code for redirecting the appointment to Soap.
            let encId = formProps.length === 1 ? formProps[0].PatientEncounterId : null,
              apptId = formProps.length === 1 ? formProps[0].PatientAppointmentId : null,
              isBillable = formProps.length === 1 ? formProps[0].IsBillableAppointment : null,
              noteTypeId = formProps.length === 1 ? formProps[0].noteTypeId : 1;             
            //if (isAdminUpdate && encId && apptId && (!isBillable || (agencyName !==  VIP && agencyName !==  AMEGO && agencyName !==  AMEGOFL && agencyName !==  ADASTRA && agencyName !==  CWO && agencyName !==  'ABCABA'  && agencyName !==  SBS))) {
            //if (isAdminUpdate && encId && apptId) {
            if (isAdminUpdate && encId && apptId && !isBillable) {
              if(agencyName ===  BEHAVIOR_BLOSSOMS)
              {
                if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else {
                  let path = isBillable ? `session-behaviorblossoms/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === DEMO || agencyName === BUILDABLOCKTHERAPY || agencyName === IAT)
              {
                if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else {
                  let path = isBillable ? `session-notes-data-collection/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName.toUpperCase().startsWith(EBS))
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `session-notes-data-collection/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } 
                else if(noteTypeId === 2){
                  let path = isBillable ? `session-notes-early-intervention/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } 
                else if(noteTypeId === 3){
                  let path = isBillable ? `session-notes-delaware-ei-ebs/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } 
                else if(noteTypeId === 4){
                  let path = isBillable ? `session-notes-ifsp-developmenttime-ebs/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
                else if(noteTypeId === 5){
                  let path = isBillable ? `session-notes-illinois-evaluation-ebs/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
                else if(noteTypeId === 6){
                  let path = isBillable ? `session-notes-illinois-ebs/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } 
              }
              else if(agencyName === CBG)
              {
                  if(noteTypeId === 1){
                    let path = isBillable ? `session-cbg/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  }
                  else if(noteTypeId === 2){
                    let path = isBillable ? `progress-note-one/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  } else if(noteTypeId === 101){
                    let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  } else if(noteTypeId === 102){
                    let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  }
              }
              else if(agencyName === AIP)
              {
                if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else {
                  let path = isBillable ? `session-aip/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }       
              else if(agencyName === NE_ABA)
              {
                if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else {
                  let path = isBillable ? `session-ne-aba/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }   
              else if(agencyName === POSITIVEBEHAVIORSTEPS)
              {
                if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else {
                  let path = isBillable ? `session-pbs/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }              
              else if(agencyName === BESTABA)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `session-bt-bestaba/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
                else if(noteTypeId === 2){
                  let path = isBillable ? `session-bcba-bestaba/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === SWANCONSULTINGINC)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
                else if(noteTypeId === 2){
                  let path = isBillable ? `session-psychological-swan/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === CAS)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
                else if(noteTypeId === 2){
                  let path = isBillable ? `progress-note-one/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === VICTORIOUSLEARNING)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
                else if(noteTypeId === 2){
                  let path = isBillable ? `progress-note-one/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === ABAORLANDO)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 2){
                  let path = isBillable ? `session-note-rbt-abaor/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 3){
                  let path = isBillable ? `session-note-bcba-abaor/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === SOAR)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 2){
                  let path = isBillable ? `session-note-assessment-soar/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 3){
                  let path = isBillable ? `session-note-directtherapy-soar/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 4){
                  let path = isBillable ? `session-note-bcbasupervision-soar/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 5){
                  let path = isBillable ? `session-note-familytreatment-soar/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 6){
                  let path = isBillable ? `session-note-diagnosticevaluation-soar/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } 
              }
              else if(agencyName === HYPERIONCENTER)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 2){
                  let path = isBillable ? `session-note-hyperion/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === HELPINGHANDS)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 2){
                  let path = isBillable ? `session-supervision-note-helpinghands/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === FUTURES)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 2){
                  let path = isBillable ? `/session-psycheval-note-futures/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 3){
                  let path = isBillable ? `/session-slpeval-note-futures/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                }
              }
              else if(agencyName === TFABA)
              {
                if(noteTypeId === 1){
                  let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 2){
                  let path = isBillable ? `session-notes-rbt-tfaba/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 3){
                  let path = isBillable ? `session-notes-bcba-tfaba/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 101){
                  let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } else if(noteTypeId === 102){
                  let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                  history.push(path);
                } 
              }
              else
              {
                  if(noteTypeId === 1){
                    let path = isBillable ? `soap/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  } else if(noteTypeId === 101){
                    let path = isBillable ? `session-notes-bt-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  } else if(noteTypeId === 102){
                    let path = isBillable ? `session-notes-bcba-default/${apptId}/${encId}/1/1` : `non-billable-soap/${apptId}/${encId}/1/1`;
                    history.push(path);
                  }
              }              
            }
          } else {
            showErrorMessage(response.message);
          }
        } else {
          dispatch(actionCreator(schedulingActionTypes.verify_Recurrence_appointments.SUCCESS, response));
        }
        // console.log('saved appointment response ...', response);

      })
      .catch(function(error) {
        console.log('error----', error);
      });
  };
};

export const getDataForScheduler = (locationId, patientId, startDateTime, endDateTime, patientInsuranceId) => {
  let query_params = `?locationId=${locationId || null}&patientId=${patientId || null}&startDate=${startDateTime || null}&endDate=${endDateTime || null}&patientInsuranceId=${patientInsuranceId || null}`;
  // console.log(`${GET_DATA_FOR_SCHEDULER_API}${query_params}`)
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_patient_details.REQUEST));
    fetch(`${GET_DATA_FOR_SCHEDULER_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        dispatch(actionCreator(schedulingActionTypes.get_patient_details.SUCCESS, response));
      }).catch(function(error) {
        console.log('getDataForScheduler...', error);
      });
  };
};

export const getDataForSchedulerForNewAppointment = (locationId, patientId, startDateTime, endDateTime, patientInsuranceId) => {
  let query_params = `?locationId=${locationId || null}&patientId=${patientId || null}&startDate=${startDateTime || null}&endDate=${endDateTime || null}&patientInsuranceId=${patientInsuranceId || null}`;
  // console.log(`${GET_DATA_FOR_SCHEDULER_API}${query_params}`)
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_patient_details.REQUEST));
    fetch(`${GET_DATA_FOR_SCHEDULER_NEWAPPOINTMENT_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        dispatch(actionCreator(schedulingActionTypes.get_patient_details.SUCCESS, response));
      }).catch(function(error) {
        console.log('getDataForScheduler...', error);
      });
  };
};

export const getPatientAuthorizationDetails = (searchObj, isUpdateAppointmentRequest = false) => {
  // console.log('searchObj..............',searchObj)
  let query_params = '';
  for (const key of Object.keys(searchObj)) {
    if (key === 'appointmentId')
      query_params = `?${key}=${searchObj[key]}`;
    else
      query_params += `&${key}=${searchObj[key]}`;
  }
  return (dispatch, getState) => {
    if (!isUpdateAppointmentRequest) {
      dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details.REQUEST));
    } else {
      dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.REQUEST));
    }
    fetch(`${GET_PATIENT_AUTHORIZATION_DETAIL_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (!isUpdateAppointmentRequest) {
          dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details.SUCCESS, response));
        } else {
          dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.SUCCESS, response));
        }
      }).catch(function(error) {
        if (!isUpdateAppointmentRequest) {
          dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details.FAILURE, null));
        } else {
          dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.FAILURE, null));
        }
        console.log('get_patient_authorization_details...', error);
      });
  };
};

export const getPatientInsuranceDetails = (data, isUpdateAppointmentRequest = false) => {
  // console.log('data..............',data)
  return (dispatch, getState) => {
    if (!isUpdateAppointmentRequest) {
      dispatch(actionCreator(schedulingActionTypes. get_patient_insurance_details.REQUEST));
    } else {
      dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.REQUEST));
    }
    fetch(`${GET_PATIENT_INSURANCE_DETAIL_API}?patientId=${data.patientId}&startDate=${data.startDate}&endDate=${data.endDate}&patientAppointmentId=${data.patientAppointmentId}&isAdmin=${data.isAdmin}&patientInsuranceId=${data.patientInsuranceId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (!isUpdateAppointmentRequest) {
          dispatch(actionCreator(schedulingActionTypes. get_patient_insurance_details.SUCCESS, response));
        } else {
          dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.SUCCESS, response));
        }
      }).catch(function(error) {
        if (!isUpdateAppointmentRequest) {
          dispatch(actionCreator(schedulingActionTypes. get_patient_insurance_details.FAILURE, null));
        } else {
          dispatch(actionCreator(schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.FAILURE, null));
        }
        console.log('get_patient_authorization_details...', error);
      });
  };
};


// export function extractDataFromObject(type, myArray, id) {
//   // let returnArr = [];
//   if (myArray !== undefined) {
//     for (var i = 0; i < myArray.length; i++) {
//       if (myArray[i].type === type && myArray[i].id === id) {
//         return myArray[i].attributes;
//       }
//     }
//   }
// }

// export function extractLocationData(type, myArray, PatientID, locationArr) {
//   let returnArr = [];
//   // let locationData = [];
//   // let locationId = '';
//   // let locationIdsArr = [];
//   if (myArray !== undefined) {
//     for (var i = 0; i < myArray.length; i++) {
//       if (myArray[i].type === type && myArray[i].attributes.PatientID === PatientID) {
//         let obj = { id: myArray[i].attributes.AddressID, value: `${myArray[i].attributes.Address1}, ${myArray[i].attributes.City}` };
//         returnArr.push(obj);
//         // locationId = myArray[i].attributes.PatientLocationID;
//         // if (!locationIdsArr.includes(locationId) && locationId != 0) {
//         //   locationData = locationArr.find((i) => i.id === locationId);
//         //   returnArr.push(locationData);
//         //   locationIdsArr.push(locationId);
//         // }
//       }
//     }
//   }
//   return returnArr;
// }


export const getPatientByName = ({ filter, keyword, locationId, pageSize, viewTeamClientsOnly }) => {
  let allPatients = [];
  let query_params = `?${filter}=${keyword}${locationId ? '&locationIDs=' + locationId : ''}&pageSize=${pageSize}&isActive=true&ViewTeamClientsOnly=${viewTeamClientsOnly}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.search_patient.REQUEST));
    fetch(`${GET_PATIENT}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          (response.data || []).forEach((patient, index) => {
            allPatients.push({
              id: patient.patientId,
              name: `${patient.firstName} ${patient.lastName}`,
              dob: moment(patient.dob).format('MM/DD/YYYY'),
              mrn_number: patient.mrn,
            });
          });
          dispatch(actionCreator(schedulingActionTypes.search_patient.SUCCESS, allPatients));
        } else {
          dispatch(actionCreator(schedulingActionTypes.search_patient.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log(error);
      });
  };
};


export const deleteAppointment = (appointment_id) => {
  // console.log('inside deleteAppointment: ', appointment_id);
  let JsonData = {
    'patientAppointment': [{
      'patientAppointmentId': appointment_id,
    }],
    'isDelete': true,
  };
  Alert.closeAll();
  return (dispatch, getState) => {

    dispatch(actionCreator(schedulingActionTypes.delete_appointment.REQUEST));

    fetch(`${POST_APPOINTMENT_API}`, {
      method: 'post',
      body: JSON.stringify(JsonData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((json) => {
        Alert.success('Appointment has been deleted successfully.', {
          position: 'bottom-right',
          effect: 'slide',
        });
        dispatch(actionCreator(schedulingActionTypes.delete_appointment.SUCCESS));
      }).catch(function(error) {
        console.log('appointment delete error (scheduling actions)...', error);
      });
  };
};


export const getInputFieldSearchData = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'appointmentType,masterstaff,MASTERPATIENTLOCATION' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(schedulingActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const getOfficeHours = (locationIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_office_hours.REQUEST));
    fetch(`${GET_OFFICE_HOURS_API}?locationIds=${locationIds}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(schedulingActionTypes.get_office_hours.SUCCESS, response));
        } else {
          dispatch(actionCreator(schedulingActionTypes.get_office_hours.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_office_hours', error);
      });
  };
};

export const getMasterTags = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_master_tags.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(schedulingActionTypes.get_master_tags.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error - get master tags (scheduling actions)', error);
      });
  };
};

export const getStaffsAvailability = (searchObj) => {
  // console.log(JSON.stringify(searchObj));
  let query_params = `?staffId=${searchObj.staffId}&locationId=${searchObj.locationId}&isLeaveNeeded=${true}`;

  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_staffs_availability.REQUEST));
    fetch(`${GET_STAFFS_AVAILABILITY}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response-->', response);
        dispatch(actionCreator(schedulingActionTypes.get_staffs_availability.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error - get staffs availability (scheduling actions)', error);
      });
  };
};

export const getClientsAvailability = (searchObj) => {
  // console.log(JSON.stringify(searchObj));
  let query_params = `?patientID=${searchObj.patientId}&locationId=${searchObj.locationId}`;

  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_clients_availability.REQUEST));
    fetch(`${GET_CLIENTS_AVAILABILITY}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response-->', response);
        dispatch(actionCreator(schedulingActionTypes.get_clients_availability.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error - get clients availability (scheduling actions)', error);
      });
  };
};

export const getPatientInsuranceById = (patientId, key, showHiddenPayer,startDateTime) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_patient_insurance_byid.REQUEST));
    fetch(`${PATIENT_PAYERS_API}?PatientID=${patientId}&Key=${key}&ShowHiddenPayer=false&startDateTime=${startDateTime || null}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(schedulingActionTypes.get_patient_insurance_byid.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientInsuranceById', error);
      });
  };
};

export const getPatientInsuranceByPatientIdAndDOS = (patientId, key, showHiddenPayer,startDateTime) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_patient_insurance_bypatientidanddos.REQUEST));
    fetch(`${PATIENT_PAYERS_BYPATIENTIDANDDOS_API}?patientId=${patientId}&key=${key}&showHiddenPayer=${showHiddenPayer}&startDateTime=${startDateTime || null}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(schedulingActionTypes.get_patient_insurance_bypatientidanddos.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientInsuranceById', error);
      });
  };
};

export const getPatientAuthorizationsList = (patientId, patientInsuranceId, startDate) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_patientAuthorizationsList.REQUEST));
    fetch(`${PATIENT_AUTHORIZATIONS_LIST_API}?patientId=${patientId}&patientInsuranceId=${patientInsuranceId}&startDate=${startDate}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(schedulingActionTypes.get_patientAuthorizationsList.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientAuthorizationsList', error);
      });
  };
};

export const updatePendingAppointmentStatus = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.update_patientAppointmentStatus.REQUEST));
    fetch(`${UPDATE_APPOINTMENT_STATUS_API}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(schedulingActionTypes.update_patientAppointmentStatus.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(schedulingActionTypes.update_patientAppointmentStatus.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error updatePendingAppointmentStatus', error);
      });
  };
};

export const updateSelectedSchedulerData = (selectedData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.update_selectedSchedulerData.SUCCESS, selectedData));
  };
};

export const sendAppointmentNotification = (appointmentId) => {
  // console.log('inside deleteAppointment: ', appointment_id);
  Alert.closeAll();
  let query_params = `?appointmentId=${appointmentId}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.update_sendAppointmentNotification.REQUEST));
    fetch(`${UPDATE_SEND_APPOINTMENT_NOTIFICATION_API}${query_params}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        Alert.success(response.message, {
          position: 'bottom-right',
          effect: 'slide',
        });
        dispatch(actionCreator(schedulingActionTypes.update_sendAppointmentNotification.SUCCESS));
      }).catch(function(error) {
        console.log('appointment delete error (scheduling actions)...', error);
      });
  };
};

export const checkClinicalRoomAvailablity = (searchObj) => {
  // console.log('searchObj..............',searchObj)
  return (dispatch, getState) => {
    // if (!isUpdateAppointmentRequest) {
      dispatch(actionCreator(schedulingActionTypes.get_patient_clinical_room_availablity.REQUEST));
    // } else {
    //   dispatch(actionCreator(schedulingActionTypes.get_patient_clinical_room_availablity_withUpdateAppointment.REQUEST));
    // }
    //let query_params = createSearchUrlForCustomAPI(searchObj);
    let query_params = `?appointmentId=${searchObj.appointmentId}&locationId=${searchObj.locationId}&startDateTime=${searchObj.startDateTime}&endDateTime=${searchObj.endDateTime}&clinicalRoomId=${searchObj.clinicalRoomId}`;
  
    fetch(`${GET_PATIENT_CLINICAL_ROOM_AVAILABILITY_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
      //  if (!isUpdateAppointmentRequest) {
          dispatch(actionCreator(schedulingActionTypes.get_patient_clinical_room_availablity.SUCCESS, response));
        // } else {
        //   dispatch(actionCreator(schedulingActionTypes.get_patient_clinical_room_availablity_withUpdateAppointment.SUCCESS, response));
        // }
      }).catch(function(error) {
        // if (!isUpdateAppointmentRequest) {
          dispatch(actionCreator(schedulingActionTypes.get_patient_clinical_room_availablity.FAILURE, null));
        // } else {
        //   dispatch(actionCreator(schedulingActionTypes.get_patient_clinical_room_availablity_withUpdateAppointment.FAILURE, null));
        // }
        console.log('get_patient_clinical_room_availablity...', error);
      });
  };
};


// Document Upload
export const UploadDocuments = (UploadFile) => {
  //console.log('JSON.stringify(UploadFile)-Action---', JSON.stringify(UploadFile));
 return (dispatch, getState) => {
   dispatch(actionCreator(schedulingActionTypes.post_UploadDocuments.REQUEST));
   fetch(`${POST_UPLOADDOCUMENTS}`, {
     method: 'post',
     headers: jsonApiHeader(getState().login.access_token, 'application/json'),
     body: JSON.stringify(UploadFile),
   })
     .then(checkHttpStatus)
     .then(function(response) {        
       if (response.statusCode === 200) {
         showSuccessMessage(response.message);
       } else if (response.statusCode === 422) {
         showWarningMessage(response.message);
       } else {
         showErrorMessage(response.message);
       }
     })
     .catch(function(error) {
       console.log('error-----', error);
     });
 };
};

export const getAuditLogsForSession = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_AuditLogsForSession.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_AUDITLOG_FORSESSION}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response......', response);
        dispatch(actionCreator(schedulingActionTypes.get_AuditLogsForSession.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};


export const setIsShowInActiveFlages = (obj) => {
  return (dispatch) => {
    dispatch(actionCreator(schedulingActionTypes.setIsShowInActiveFlages.SUCCESS,obj))
  }
}




/////////////
export const getInActiveStaffAndPatientByLocation = (searchObj,isCallFromDailog,showInActiveStaffOnly="ACTIVEONLY",showInActivePatientOnly="ACTIVEONLY") =>{
  
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=${searchObj.permissionKey}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnly}&showInActivePatientOnly=${showInActivePatientOnly}&showInActiveStaffOnly=${showInActiveStaffOnly}`;
  // console.log(`${GET_STAFF_AND_PATIENT_BYLOCATION}?locationId=${locationId}`);
  return (dispatch, getState) => {

    if (isCallFromDailog) {
      dispatch(actionCreator(schedulingActionTypes.get_staff_and_patient_bySingleLocation.REQUEST));
    } else {
      dispatch(actionCreator(schedulingActionTypes.getInActiveStaffAndPatientByLocation.REQUEST));
    }


    fetch(`${GET_IN_ACTIVE_STAFF_AND_PATIENT_BY_LOCATION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        if(isCallFromDailog){
          dispatch(actionCreator(schedulingActionTypes.get_staff_and_patient_bySingleLocation.REQUEST));
        } else{
          dispatch(actionCreator(schedulingActionTypes.getInActiveStaffAndPatientByLocation.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('get InActive staff and client by location error', error);
      });
  };
}



export const getOnlyInActiveStaffAndPatientsByLocation = (searchObj,isCallFromDailog) =>{
  const showInActiveStaffOnly="INACTIVEONLY";
  const showInActivePatientOnly="INACTIVEONLY";
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=${searchObj.permissionKey}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnly}&showInActivePatientOnly=${showInActivePatientOnly}&showInActiveStaffOnly=${showInActiveStaffOnly}`;
  // console.log(`${GET_STAFF_AND_PATIENT_BYLOCATION}?locationId=${locationId}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.getOnlyInActiveStaffAndPatientsByLocation.REQUEST));
    fetch(`${GET_ONLY_IN_ACTIVE_STAFF_AND_PATIENTS_BY_LOCATION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(schedulingActionTypes.getOnlyInActiveStaffAndPatientsByLocation.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get Only InActive staff and client by location error', error);
      });
  };
}

export const getAppointmentTypeDefaultSetting = (appointment_type_id) => {
  // let query_params = createSearchUrl(searchObj);
  // console.log(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(schedulingActionTypes.get_AppointmentType_Default_Setting.REQUEST));
    fetch(`${GET_APPOINTMENTTYPE_DEFAULT_SETTING}?appointmentTypeID=${appointment_type_id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(schedulingActionTypes.get_AppointmentType_Default_Setting.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get appointment_by_id error', error);
      });
  };
};




//////////////


// WEBPACK FOOTER //
// ./src/modules/scheduling/actions/SchedulingActions_NewFeatures.js